export default __webpack_public_path__ + "static/media/campaignComplete-icon-blue.d43be4b0.svg";